import { connect } from 'react-redux'
import ConnectedQAMenu from 'pages/qamenu/ConnectedQAMenu'

const mapStateToProps = state => ({
  isTiledMenuLoaded: state.placeholders.isTiledMenuLoaded,
  headerHeight: state.layout.headerHeight,
  isMobile: state.layout.deviceType.isMobile,
  showFavouritesOnly: state.qa.showFavouritesOnly,
  keyword: state.qa.keyword
})

export default connect(mapStateToProps)(ConnectedQAMenu)
